const HTTP = '/'

export default HTTP
